module.exports = __webpack_public_path__ + "img/P09-19830626-001_3.083dde57.jpg";